<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="my-xl mx">

  <div class="p-field pb col-12" >
          <span class="">
             <label class="mr">{{'company.subscription-type.subscription.legalEntity' | translate}} </label>
               <well-legal-entity-inputs #legalEntityForm (save)="onCompanySelected($event)" (validCompanySelected)="onCompanySelected($event)" [showEmailImportSettings]="false" data-testid="legal-entity-input">

                </well-legal-entity-inputs>
           </span>
  </div>

  <p-messages [value]="msg | async"></p-messages>


  <div class="mt pull-right">
    <button pButton [label]="'company.utils.cancel' | translate" type="button"
            class="mr-sm flat p-button-text" (click)="goBack()" data-testid="go-back-btn"></button>
    <button pButton [label]="'company.utils.save' | translate" type="submit"
            (click)="legalEntityForm.onSubmit()" data-testid="legal-entity-form-on-submit-btn"></button>
  </div>

</div>


